import Cookies from "js-cookie";

const getUiLanguage: () => string = () => {
    //TODO all languages
    let languageId = Cookies.get("uiLanguageId") ?? "0";

    switch (parseInt(languageId, 10)) {
        case 1:
            return "en";
        case 128:
            return "pl";
        default:
            return "en";
    }
};

export default getUiLanguage;
